import { c as _c } from "react/compiler-runtime";
import { DateFormatter } from "@sticker-giant/sg-frontend-common";
import { Suspense } from "react";
import { BlogImage } from "@/components/custom/BlogImage";
import { BlogImageSkeleton } from "@/components/custom/BlogImageSkeleton";
import { parseLocalDate } from "@/lib/contentful/dates";
import type { ContentImage } from "@/types/contentful/ContentImage";
interface Props {
  headline: string;
  introSummary: string;
  publishedDate: string;
  image: ContentImage | null;
  imageEntryId?: string;
}
export const BlogArticleHeader = t0 => {
  const $ = _c(17);
  const {
    headline,
    introSummary,
    publishedDate,
    image,
    imageEntryId
  } = t0;
  let t1;
  if ($[0] !== publishedDate) {
    const date = parseLocalDate(publishedDate);
    t1 = DateFormatter.formatToReadableDate(date);
    $[0] = publishedDate;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  const formattedDate = t1;
  let t2;
  if ($[2] !== headline) {
    t2 = <h1 className="text-4xl font-black tracking-normal">{headline}</h1>;
    $[2] = headline;
    $[3] = t2;
  } else {
    t2 = $[3];
  }
  let t3;
  if ($[4] !== introSummary) {
    t3 = <p className="text-base font-normal leading-normal py-6">{introSummary}</p>;
    $[4] = introSummary;
    $[5] = t3;
  } else {
    t3 = $[5];
  }
  let t4;
  if ($[6] !== formattedDate || $[7] !== publishedDate) {
    t4 = <time dateTime={publishedDate} className="text-xs font-normal leading-none">{formattedDate}</time>;
    $[6] = formattedDate;
    $[7] = publishedDate;
    $[8] = t4;
  } else {
    t4 = $[8];
  }
  let t5;
  if ($[9] !== image || $[10] !== imageEntryId) {
    t5 = image && <div className="mt-6"><Suspense fallback={<BlogImageSkeleton />}><BlogImage image={image} featured={true} priority={true} entryId={imageEntryId} /></Suspense></div>;
    $[9] = image;
    $[10] = imageEntryId;
    $[11] = t5;
  } else {
    t5 = $[11];
  }
  let t6;
  if ($[12] !== t2 || $[13] !== t3 || $[14] !== t4 || $[15] !== t5) {
    t6 = <header className="pt-12 pb-6 px-6 mb-8 max-w-3xl mx-auto w-full">{t2}{t3}{t4}{t5}</header>;
    $[12] = t2;
    $[13] = t3;
    $[14] = t4;
    $[15] = t5;
    $[16] = t6;
  } else {
    t6 = $[16];
  }
  return t6;
};